(globalThis as any).process = { env: {} };

export const appconfig = {
  idp: process.env.APPCONFIG_IDENTITY_SERVICE_ADDRESS ?? 'http://localhost:9000',
};
